export const CROP_PLANTING_EVENT_LIST_VIEW = "/crop-planting-events"
export const NEW_CROP_PLANTING_EVENT_VIEW =
  CROP_PLANTING_EVENT_LIST_VIEW + "/new"
export const CROP_PLANTING_EVENT_VIEW = `${CROP_PLANTING_EVENT_LIST_VIEW}/:cropPlantingEventId`
